import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Supply from "../components/Supply";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import Banner from "../components/Banner";
import Mission from "../components/Mission";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { Helmet } from "react-helmet-async";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(
        location.hash.replace("#", "")
      );

      el?.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  return (
    <>
      {/* SEO */}
      <Helmet>
        <title>
          Aranya Nutraceuticals | Herbal Extracts &
          Essential Oils Supplier
        </title>

        <meta
          name="description"
          content="Aranya Nutraceuticals is a premium supplier of herbal extracts, essential oils, nutraceutical ingredients, and herbal raw materials in India."
        />

        <meta
          name="keywords"
          content="herbal extracts, essential oils, nutraceutical ingredients, herbal raw materials, piperine extract, onion oil"
        />

        <meta
          property="og:title"
          content="Aranya Nutraceuticals"
        />

        <meta
          property="og:description"
          content="Premium herbal extracts and essential oils supplier in India."
        />

        <meta
          property="og:image"
          content="/images/banner1.webp"
        />

        <meta property="og:type" content="website" />
      </Helmet>

      <Navbar />

      <Hero />

      {/* <Products /> */}

      <Supply />

      <Banner />

      <About />

      <Mission />

      <Contact />

      <Footer />
    </>
  );
};

export default Home;